/**
 * Phonics Letter Ee — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/ee/）
 * 开发环境通过 public/media/phonics/ee/ 访问，生产环境由 NGINX 提供
 */

const MEDIA_BASE = '/media/phonics/ee';
const V = 'v1';

export const letterData = {
  letter: 'E',
  title: 'Phonics',
  subtitle: 'Letter E',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Ee.mp4?${V}`,
    startTime: 10,
    endTime: 87,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image12.png?${V}` },
  ],

  // Step 3-4: Vocab (video-left-vocab-right)
  // Step 5-8: Story (video-top-lines-bottom)
  storySections: [
    // Step 3: Learn the words (1) — did / you / see + Did you see my eggs?
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_did_you_see.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'did', cn: '做过..事情', audioEn: `${MEDIA_BASE}/w_en_did.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_did.mp3?${V}` },
        { en: 'you', cn: '你', audioEn: `${MEDIA_BASE}/w_en_you.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_you.mp3?${V}` },
        { en: 'see', cn: '看到', audioEn: `${MEDIA_BASE}/w_en_see.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_see.mp3?${V}` },
        { en: 'Did you see my ...?', cn: '你看到 ... 了吗？', audioEn: `${MEDIA_BASE}/s_en_did_you_see_my_ellipsis.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_did_you_see_my_ellipsis.mp3?${V}` },
      ],
    },

    // Step 4: Learn the words (2) — No / didn't + No, I didn't.
    {
      label: 'Learn the words (2)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words2_no_didnt.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      splitAt: 2,
      lines: [
        { en: 'No', cn: '不', audioEn: `${MEDIA_BASE}/w_en_no.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_no.mp3?${V}` },
        { en: "didn't", cn: '没做过..', audioEn: `${MEDIA_BASE}/w_en_didnt.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_didnt.mp3?${V}` },
        { en: "No, I didn't.", cn: '不，我没看到。', audioEn: `${MEDIA_BASE}/s_en_no_i_didnt.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_no_i_didnt.mp3?${V}` },
      ],
    },

    // Step 5-8: Story (video-top-lines-bottom)
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ee_1.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'Where are my eggs?', cn: '我的蛋在哪里？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ee_2.mp4?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` }],
      lines: [
        { en: 'Did you see my eggs?', cn: '你看到我的蛋了吗？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: "No, I didn't.", cn: '不，我没看到。', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ee_3.mp4?${V}`, poster: `${MEDIA_BASE}/image17.png?${V}` }],
      lines: [
        { en: 'Did you see my eggs?', cn: '', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: null },
        { en: "No, I didn't.", cn: '', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: null },
      ],
    },
    {
      label: 'Learn the Story (4)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ee_4.mp4?${V}`, poster: `${MEDIA_BASE}/image18.png?${V}` }],
      lines: [
        { en: 'Did you see my eggs?', cn: '', audioEn: `${MEDIA_BASE}/story4_en_1.mp3?${V}`, audioCn: null },
        { en: 'Yes, I did.', cn: '是的，我看到了。', audioEn: `${MEDIA_BASE}/story4_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story4_cn_2.mp3?${V}` },
      ],
    },
  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
